"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _reactComponents = require("@ui-propulsion/react-components");
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
require("./styles.scss");
/* eslint-disable react/no-danger */

var CheckboxControlled = function CheckboxControlled(_ref) {
  var control = _ref.control,
    name = _ref.name,
    labelText = _ref.labelText,
    isRequired = _ref.isRequired,
    centered = _ref.centered,
    errorMessage = _ref.errorMessage;
  var _useController = (0, _reactHookForm.useController)({
      name: name,
      control: control,
      rules: {
        required: {
          value: isRequired,
          message: errorMessage
        }
      }
    }),
    field = _useController.field,
    error = _useController.fieldState.error;
  var checkboxClasses = (0, _classnames.default)('custom-checkbox', {
    'custom-checkbox--error': error
  });
  var aligned = centered ? 'center' : 'flex-start';
  var createMarkup = function createMarkup(text) {
    return {
      __html: text
    };
  };
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    spacing: 1,
    alignItems: aligned,
    className: checkboxClasses
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: name,
    "aria-label": labelText
  }, /*#__PURE__*/_react.default.createElement("input", Object.assign({
    "aria-labelledby": "checkbox-label",
    type: "checkbox",
    id: name,
    "data-test-id": name
  }, field)), /*#__PURE__*/_react.default.createElement("div", {
    id: "checkbox-label",
    dangerouslySetInnerHTML: createMarkup(labelText)
  })), error && /*#__PURE__*/_react.default.createElement("label", {
    className: "input--error",
    htmlFor: name,
    role: "alert"
  }, error.message));
};
CheckboxControlled.defaultProps = {
  isRequired: false,
  centered: false,
  errorMessage: 'This is required'
};
CheckboxControlled.propTypes = {
  control: (0, _propTypes.shape)({}).isRequired,
  name: _propTypes.string.isRequired,
  labelText: _propTypes.string.isRequired,
  isRequired: _propTypes.bool,
  centered: _propTypes.bool,
  errorMessage: _propTypes.string
};
var _default = CheckboxControlled;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-refunds/lib/components/CheckboxControlled/styles.scss');